import React from "react"
import Modal from "react-bootstrap/Modal"
import * as styles from "./Styles/ImageModal.module.scss"

const ImageModal = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} className={styles.modal}>
      <Modal.Header closeButton className={styles.modalHeader} />
      <div className={styles.container}>
        {props.image && <img src={props.image.url} />}
        {props.image && props.image.copyright && (
          <React.Fragment>
            {props.image.copyrightUrl && (
              <div className={styles.copyright}>
                <a href={props.image.copyrightUrl} target="_blank">
                  {props.image.copyright}
                </a>
              </div>
            )}
            {!props.image.copyrightUrl && (
              <div className={styles.copyright}>{props.image.copyright}</div>
            )}
          </React.Fragment>
        )}
      </div>
    </Modal>
  )
}
export default ImageModal
